import { formatValueUnit } from "./utils";

const labelBarFontSize = 11;
const labelBarFontWeight = 600;

export const barColors = {
  blue: "#069dde",
  orange: "#ff9432",
  red: "#c90000ff",
  gray: "#4a4a4a",
};

export const barChartMargin = {
  top: 20,
  right: 0,
  left: 25,
  bottom: 20,
};

export const axisStyle = {
  fontSize: 13,
  fontFamily: "Montserrat",
  fontWeight: 500,
};

export const axisXLabel = (label) => {
  return {
    value: label,
    position: "insideBottom",
    offset: -5,
    style: { fill: barColors.gray, fontSize: 14 },
    dy: 5,
  };
};

export const axisYLabel = (label) => {
  return {
    value: label,
    angle: -90,
    position: "insideLeft",
    style: {
      textAnchor: "middle",
      fill: barColors.gray,
      fontSize: 14,
    },
    dx: -20,
  };
};

export const legendStyle = { marginTop: 0, marginLeft: 60 };

export const titleStyle = {
  textAlign: "center",
  fontWeight: labelBarFontWeight,
  fontSize: "16px",
  color: barColors.gray,
};

export const xAxisTick = ({ x, y, payload }) => {
  const text = payload.value;
  const words = text.split(" ");

  // Coordenadas de anclaje
  const translateX = x;
  const translateY = y + 10;

  if (words.length === 1) {
    return (
      <g transform={`translate(${translateX}, ${translateY}) rotate(-45)`}>
        <text textAnchor="end" fontSize={12} fill={barColors.gray}>
          {text}
        </text>
      </g>
    );
  }

  // Si hay más de una palabra, divide en dos líneas
  const middle = Math.ceil(words.length / 2);
  const firstLine = words.slice(0, middle).join(" ");
  const secondLine = words.slice(middle).join(" ");

  return (
    <g transform={`translate(${translateX}, ${translateY}) rotate(-45)`}>
      <text textAnchor="end" fontSize={12} fill={barColors.gray}>
        <tspan x={0} dy="0">
          {firstLine}
        </tspan>
        <tspan x={0} dy="1.2em">
          {secondLine}
        </tspan>
      </text>
    </g>
  );
};

export const getHistoricalBarLabel = (
  dataList,
  valueField,
  percentField,
  color = barColors.blue
) => {
  return ({ x, y, width, index }) => {
    const data = dataList[index];
    if (!data) {
      return null;
    }
    return (
      <>
        <text
          x={x + width / 2}
          y={y - 20}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          {data[valueField]}
        </text>
        <text
          x={x + width / 2}
          y={y - 5}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          ({data[percentField]} %)
        </text>
      </>
    );
  };
};

export const getPMVBarLabel = (
  dataList,
  valueField,
  percentField,
  color = barColors.blue
) => {
  return ({ x, y, width, index }) => {
    const data = dataList[index];
    if (!data) {
      return null;
    }
    return (
      <>
        <text
          x={x + width / 2}
          y={y - 20}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          {formatValueUnit(data[valueField], "€")}
        </text>
        <text
          x={x + width / 2}
          y={y - 5}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          ({data[percentField]} ops)
        </text>
      </>
    );
  };
};

export const getProfitBarLabel = (
  dataList,
  valueField,
  percentField,
  color = barColors.blue
) => {
  return ({ x, y, width, index }) => {
    const data = dataList[index];
    if (!data) {
      return null;
    }
    return (
      <>
        <text
          x={x + width / 2}
          y={y - 20}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          {formatValueUnit(data[valueField], "€")}
        </text>
        <text
          x={x + width / 2}
          y={y - 5}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          ({data[percentField]} %)
        </text>
      </>
    );
  };
};

export const getStoreStatsPopupBarLabel = (
  dataList,
  valueField,
  unit,
  color = barColors.blue
) => {
  return ({ x, y, width, index }) => {
    const data = dataList[index];
    if (!data) {
      return null;
    }
    return (
      <>
        <text
          x={x + width / 2}
          y={y - 20}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        >
          {formatValueUnit(data[valueField], unit)}
        </text>
        <text
          x={x + width / 2}
          y={y - 5}
          fill={color}
          fontSize={labelBarFontSize}
          textAnchor="middle"
          fontWeight={labelBarFontWeight}
        ></text>
      </>
    );
  };
};
